import React, { useEffect, useState, useRef } from 'react';

import { Box, TextField } from '@mui/material';

import SelectModel from './SelectModel';
import { useCopilotStyles } from './styles';
import { IParagraphQueue, IAIScore } from '../../global/interfaces';
import { scrollToBottom } from '../../utils/helpers';

import { useCopilotContext } from '../../contexts/CopilotContext';

import { AI_MODES_IDX } from '../../global/constants/general';

const { CLASSIFY, FILTER, SEARCH } = AI_MODES_IDX;

const CopilotSearch = () => {
  const styles = useCopilotStyles();
  const [searchString, setSearchString] = useState<string>('');
  const [hideSearchTextResults, setHideSearchTextResults] =
    useState<boolean>(false);

  const {
    searchResults,
    searchEnqueue,
    documentParagraphMapRef,
    setDocumentParagraphQueue,
    setSelectedSentenceId,
    transcriptSentenceMapRef,
  } = useCopilotContext();

  const handleSearchStringChange = (event: any) => {
    setSelectedSentenceId('');
    setSearchString(event.target.value);
  };

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter')
      searchEnqueue({
        sid: '',
        text: searchString,
      });
  };

  const jumpToSection = (s: string) => {};

  useEffect(() => {
    if (!searchResults) return;

    const documentParagraphQueue: IParagraphQueue[] = [];

    searchResults.scores.forEach((score: IAIScore, index: number) => {
      const paragraph = documentParagraphMapRef?.current?.get(
        `${score.did}-${score.idx}`,
      );

      if (!paragraph?.text) {
        documentParagraphQueue.push({ did: score.did, idx: score.idx });
        console.log(`missing paragraph[_${score.idx}] score:`, score);
      }
    });

    if (documentParagraphQueue.length > 0) {
      setDocumentParagraphQueue(documentParagraphQueue);
      console.log('documentParagraphQueue:', documentParagraphQueue);
    }
  }, [searchResults]);

  const scrollableElRef = useRef<any>();
  const sentenceMap = transcriptSentenceMapRef.current;
  useEffect(() => {
    setSearchString(
      searchResults?.text
        ? searchResults.text
        : searchResults?.sid && sentenceMap?.get(searchResults.sid)?.text
          ? sentenceMap.get(searchResults.sid)?.text
          : '',
    );
    scrollToBottom(scrollableElRef);
  }, [searchResults]);

  return (
    <>
      <Box style={{ marginTop: '1rem', minHeight: '3rem' }}>
        <SelectModel
          aiModeIndex={SEARCH}
          hideSearchTextResults={hideSearchTextResults}
          setHideSearchTextResults={setHideSearchTextResults}
        />
      </Box>
      <Box>
        <TextField
          sx={styles.textField}
          label="Search text"
          value={searchString}
          onChange={handleSearchStringChange}
          onKeyPress={handleKeyPress}
        />
        <Box ref={scrollableElRef}>
          {searchResults?.scores.map((score: IAIScore, index: number) => {
            const paragraph = documentParagraphMapRef?.current?.get(
              `${score.did}-${score.idx}`,
            );
            if (!paragraph || !paragraph.text) {
              console.log(`missing paragraph[_${score.idx}] score:`, score);
              return '';
            }

            return (
              <div key={index} style={{ padding: '.25rem 0' }}>
                {!hideSearchTextResults && (
                  <div
                    onClick={() =>
                      jumpToSection(
                        `section-${paragraph.ref.page}.${paragraph.ref.idx}`,
                      )
                    }>
                    <i style={{ color: '#088' }}>
                      Score {Number(score.score).toFixed(2)}:
                    </i>{' '}
                    {paragraph.text}
                  </div>
                )}
                {paragraph.ref.illustrations.map((name: string) => (
                  <div
                    key={name}
                    onClick={() => jumpToSection(`img-${name}`)}
                    className="illustration">
                    <img
                      style={{ maxWidth: '25vw', maxHeight: '25vh' }}
                      src={`${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/img/pdf-${name}.png`}
                      alt={`Illustration ${name}`}
                    />
                  </div>
                ))}
              </div>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default CopilotSearch;
